module.exports = __webpack_public_path__ + "static/img/idtroc-video-poster.b2878d7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/idtroc-video-poster.gif
// module id = FOQa
// module chunks = 1